module.exports = __webpack_public_path__ + "static/media/Retro-Sprint-4-Audio-1.0aa88133.mp3";